export const selectiva = {
  id: "selectiva",
  type: "playlist",
  featured: false,
  title: "Selectiva",
  link: "selectiva",
  playlistBg: "rgb(136, 255, 223)",
  imgUrl: "/image/set/listas/selectiva.jpg",
  hoverColor: "rgb(136, 255, 223)",
  artist: "Amy Moon",
  artistImgUrl: "/image/external-artist/amy-moon.jpg",
  artistBio: "Amy Moon",
  artistDownload: "Descargar",
  bannerUno: "",
  downloadData: [],
  playlistImages: [],
  playlistData: [
    {
      id: "2",
      songName: "Selectiva",
      songimg: "../image/set/listas/selectiva.jpg",
      songArtist: "Amy Moon",
      artistLink: "amy-moon",
      link: "https://kzxhfwrnnuncrdmzaypg.supabase.co/storage/v1/object/sign/tracks/Amy%20Moon%20-%20Selectiva.mp3?token=eyJraWQiOiI2MmYwZmFhMi0wMTFlLTRlZTUtOGNhZC05YWNjMzUwMjU4ODYiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJ0cmFja3MvQW15IE1vb24gLSBTZWxlY3RpdmEubXAzIiwic2NvcGUiOiJkb3dubG9hZCIsImlhdCI6MTc4NzkzOTUzNywiZXhwIjoxODUxMDExNTM3fQ.iY-7OtB5UUk0XqSrnvAAaJANYESBOcawWfNpKuBt2uU",
      genre: "blues",
      trackTime: "02:32",
      index: 0,
      genres: []
    }
  ]
}
